import React from 'react';
import './PageHeader.css';

/**
 * Shared section header — the dark banner used across the app (mirrors the Order / Authorization /
 * Proforma look). Presentation only; carries no logic.
 *
 * @param {React.ReactNode} icon      Icon element shown in the rounded badge (e.g. <FaList size={22} />).
 * @param {React.ReactNode} title     Page title.
 * @param {React.ReactNode} subtitle  Optional one-line description under the title.
 * @param {React.ReactNode} actions   Optional right-aligned actions (buttons, etc.).
 */
const PageHeader = ({ icon, title, subtitle, actions }) => (
  <div className="page-header">
    <div className="page-header-left">
      {icon != null && <div className="page-header-icon">{icon}</div>}
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
    {actions && <div className="page-header-actions">{actions}</div>}
  </div>
);

export default PageHeader;
